import { render } from "./edit-name.vue?vue&type=template&id=11d69d2e&scoped=true&ts=true"
import script from "./edit-name.vue?vue&type=script&lang=tsx"
export * from "./edit-name.vue?vue&type=script&lang=tsx"

import "./edit-name.vue?vue&type=style&index=0&id=11d69d2e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d69d2e"]])

export default __exports__